var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inner-table',{ref:"contractList",attrs:{"id":"innerTableContract","listviewurl":'teacher.contractInfo.list',"can-edit":0,"can-delete":1,"link-prop-name":'orgCode'}})
}
var staticRenderFns = []

export { render, staticRenderFns }